/*
COMMON.JS
-
- current page highlight
- external link
- PDF target brank
- hamburger
*/
'use strict';
// Scroll status management
let lastScrollY = 0;
const SCROLL_DIRECTION_THRESHOLD = 4;

const updateScrollStatus = () => {
    const currentScrollY = Math.max(0, window.scrollY || window.pageYOffset);
    const body = document.body;
    const scrollDiff = currentScrollY - lastScrollY;

    // Determine status
    let status;
    if (currentScrollY === 0) {
        status = 'top';
    } else if (currentScrollY < 600) {
        status = 'first-view';
    } else {
        // Ignore tiny oscillation around the same position.
        if (Math.abs(scrollDiff) < SCROLL_DIRECTION_THRESHOLD) {
            return;
        }

        // Determine scroll direction
        if (scrollDiff > 0) {
            status = 'down';
        } else {
            status = 'up';
        }
    }

    body.setAttribute('data-scroll-status', status);
    lastScrollY = currentScrollY;
};

// Initialize scroll status
updateScrollStatus();
window.addEventListener('scroll', updateScrollStatus, { passive: true });
window.addEventListener('resize', updateScrollStatus);

document.addEventListener('DOMContentLoaded', () => {
    const updateHeaderStopAtFooter = () => {
        const header = document.querySelector('.l-header');
        const footer = document.querySelector('footer');
        if (!header || !footer) {
            return;
        }

        const footerTop = footer.getBoundingClientRect().top;
        const headerHeight = header.offsetHeight;
        const headerTopOffset = parseFloat(window.getComputedStyle(header).top) || 0;
        const stopGap = 42;
        const overlap = headerTopOffset + headerHeight + stopGap - footerTop;

        header.style.transform = overlap > 0 ? `translateY(${-overlap}px)` : 'translateY(0)';
    };

    updateHeaderStopAtFooter();
    window.addEventListener('scroll', updateHeaderStopAtFooter, { passive: true });
    window.addEventListener('resize', updateHeaderStopAtFooter);

    // 現在のページをハイライト
    const gNaviLinks = document.querySelectorAll(
        '.l-header__nav a,.p-information .c-tabList a',
    );
    const currentUrl = new URL(location.href);
    const currentPath = currentUrl.pathname.replace(/\/$/, '');
    gNaviLinks.forEach((gNaviLink) => {
        const linkUrl = new URL(gNaviLink.href, location.href);
        const linkPath = linkUrl.pathname.replace(/\/$/, '');
        const isSamePath = linkPath === currentPath;
        if (linkUrl.href === currentUrl.href || isSamePath) {
            gNaviLink.classList.add('is-current');
        }
        //header内のみ親階層もcurrentを付ける
        if (gNaviLink.closest('header')) {
            if (currentUrl.pathname.indexOf(linkUrl.pathname) === 0 && !isSamePath) {
                gNaviLink.classList.add('is-current');
            }
        }
    });

    //外部リンク設定
    const externalLinkItems = document.querySelectorAll('a.js-externallink');
    externalLinkItems.forEach((externalLinkItem) => {
        externalLinkItem.classList.add('externalLink');
        externalLinkItem.setAttribute('target', '_blank');
    });

    //PDF target brank
    const pdfLinkItems = document.querySelectorAll(
        'a[href$=".pdf"],a[href$=".asx"]',
    );
    pdfLinkItems.forEach((pdfLinkItem) => {
        pdfLinkItem.classList.add('pdfLink');
        pdfLinkItem.setAttribute('target', '_blank');
        pdfLinkItem.setAttribute('rel', 'noopener');
    });

    //hamburger
    const hamburgerBtn = document.querySelector('.hamburger');
    const mobileMenu = document.querySelector('.js-mobile-menu');
    if (hamburgerBtn) {
        if (mobileMenu === null) {
            console.warn('<div class="js-mobile-menu"></div>が見つかりませんでした。');
            return;
        }
        const MOBILE_MAX_WIDTH = 992;
        const mobileMq = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`);
        const mobileMenuItems = mobileMenu.querySelectorAll(
            '.l-header__nav__inner a, .l-header__subNav a, .l-header__btnArea a',
        );
        const accordionItems = mobileMenu.querySelectorAll('.l-header__nav > .item');

        const closeAllAccordions = () => {
            accordionItems.forEach((accordionItem) => {
                accordionItem.classList.remove('is-open');
                const parentLink = accordionItem.querySelector('.link');
                if (parentLink) {
                    parentLink.setAttribute('aria-expanded', 'false');
                }
            });
        };

        const syncMobileMenuMode = () => {
            if (!mobileMq.matches) {
                document.body.classList.remove('is-mobile-menu-open');
                hamburgerBtn.classList.remove('is-active');
                mobileMenu.classList.remove('is-open');
                mobileMenu.removeAttribute('inert');
                closeAllAccordions();
                return;
            }

            if (mobileMenu.classList.contains('is-open')) {
                mobileMenu.removeAttribute('inert');
            } else {
                mobileMenu.setAttribute('inert', true);
            }
        };

        function openMobileMenu(e) {
            if (!mobileMq.matches) {
                return;
            }
            document.body.classList.toggle('is-mobile-menu-open');
            e.currentTarget.classList.toggle('is-active');
            mobileMenu.classList.toggle('is-open');
            syncMobileMenuMode();
        }
        function closeMobileMenu(e) {
            if (!mobileMq.matches) {
                return;
            }
            document.body.classList.remove('is-mobile-menu-open');
            hamburgerBtn.classList.remove('is-active');
            mobileMenu.classList.remove('is-open');
            mobileMenu.setAttribute('inert', true);
            closeAllAccordions();
        }
        hamburgerBtn.addEventListener('click', openMobileMenu);
        mobileMenuItems.forEach((mobileMenuItem) => {
            mobileMenuItem.addEventListener('click', closeMobileMenu);
        });

        accordionItems.forEach((accordionItem) => {
            const parentLink = accordionItem.querySelector('.link');
            if (!parentLink) {
                return;
            }

            parentLink.setAttribute('aria-expanded', 'false');
            parentLink.addEventListener('click', (event) => {
                if (!mobileMq.matches) {
                    return;
                }

                event.preventDefault();
                const willOpen = !accordionItem.classList.contains('is-open');
                closeAllAccordions();

                if (willOpen) {
                    accordionItem.classList.add('is-open');
                    parentLink.setAttribute('aria-expanded', 'true');
                }
            });
        });

        syncMobileMenuMode();
        window.addEventListener('resize', syncMobileMenuMode);
    }

    //Tellink
    const uaLower = navigator.userAgent.toLowerCase();
    const isMobileDevice = /(iphone|android)/.test(uaLower);
    if (isMobileDevice) {
        //スマホで閲覧した時は電話番号にリンク追加
        const telLinks = document.querySelectorAll('[data-tellink]');
        telLinks.forEach((telLInk) => {
            const telNumber = telLInk.getAttribute('data-tellink');
            telLInk.innerHTML = `<a href="tel:${telNumber}">${telLInk.textContent}</a>`;
        });
        $('.js-table').each(function () {
            $(this).wrapAll('<div class="tableScroll">');
        });
    }
});
